import {useGetInfiniteDiscards} from '@/modules/stocks/discards/api'
import {DiscardsHeader} from '@/modules/stocks/discards/components/discards-header'
import {DiscardsTable} from '@/modules/stocks/discards/components/discards-table'
import {DiscardsSearchSchema} from '@/modules/stocks/discards/schemas'
import {Box} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {type OnChangeFn, type SortingState} from '@tanstack/react-table'
import {useCallback} from 'react'

export const Route = createFileRoute('/stocks/discards/')({
  component: DiscardsPage,
  validateSearch: DiscardsSearchSchema,
})

const LIMIT = 50

function DiscardsPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  const [sort] = search.sort

  const infiniteDiscards = useGetInfiniteDiscards({
    limit: LIMIT,
    sort: {
      dir: sort?.desc ? 'desc' : 'asc',
      field: sort?.id || 'createdAt',
    },
    filters: {
      search: search.filters?.search,
      types: search.filters?.types,
      reasons: search.filters?.reasons,
      substances: search.filters?.substances,
      createdAtFrom: search.filters?.createdAtFrom,
      createdAtTo: search.filters?.createdAtTo,
      status: [],
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infiniteDiscards

  const onSortingChange = useCallback<OnChangeFn<SortingState>>(
    updaterOrValue => {
      const newValue = typeof updaterOrValue === 'function' ? updaterOrValue(search.sort) : updaterOrValue
      navigate({to: '.', search: prev => ({...prev, sort: newValue})})
    },
    [navigate, search.sort]
  )

  return (
    <>
      <Box flexShrink={0}>
        <DiscardsHeader />
      </Box>

      <DiscardsTable
        virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
        table={{onSortingChange, state: {sorting: search.sort}}}
      />
    </>
  )
}
